import React from 'react';

const ExpensightLogo = ({ className = "h-8 w-auto", showText = true, textColor = "text-white" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Icon */}
      <svg 
        className="h-8 w-8 mr-2" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background Circle */}
        <circle cx="20" cy="20" r="20" fill="url(#gradient)" />
        
        {/* Eye Icon (representing "sight") */}
        <path 
          d="M20 12C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12Z" 
          fill="white" 
          fillOpacity="0.9"
        />
        
        {/* Inner Eye */}
        <circle cx="20" cy="20" r="4" fill="#3B82F6" />
        <circle cx="20" cy="20" r="2" fill="white" />
        
        {/* Dollar Sign */}
        <path 
          d="M19 14V16M19 24V26M16 18C16 16.8954 16.8954 16 18 16H20C21.1046 16 22 16.8954 22 18C22 19.1046 21.1046 20 20 20H18C16.8954 20 16 20.8954 16 22C16 23.1046 16.8954 24 18 24H20C21.1046 24 22 23.1046 22 22" 
          stroke="white" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          opacity="0.7"
        />
        
        {/* Gradient Definition */}
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="50%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#8B5CF6" />
          </linearGradient>
        </defs>
      </svg>
      
      {/* Logo Text */}
      {showText && (
        <span className={`text-xl font-bold ${textColor}`}>
          Expensight
        </span>
      )}
    </div>
  );
};

export default ExpensightLogo;